/// <reference path="../resetPassword/resetPassword.js" />

(function () {
    app.controller('upgradeServiceController', ['$scope', '$location', '$cookies', 'LoginService', 'AuthenticationService', 'progressBarService', '$rootScope', '$timeout', 'UpgradeService', function ($scope, $location, $cookies, loginService, AuthenticationService, progressBarService, $rootScope, $timeout, upgradeService) {

        if ($cookies.get('TokenInfo') == undefined || localStorage.getItem('appInfo') == undefined) {
            $location.path('/login');
            return;
        }
        
        $scope.states = [];
        $scope.billingstates = [];
        $scope.isError = false;
        $scope.isSuccess = false;
        $scope.institutionName = getLocalValue('affiliationName');
        $scope.roleStatus = getLocalValue('userRoleStatus');
        $scope.isInstitution = ($scope.roleStatus == 'active' && $scope.institutionName != '') ? 1 : 0;
        
        var name = getLocalValue("fullName").split(' ');
        $scope.firstName = name[0];
        $scope.lastName = name[1];

        $scope.purchasedCostEstimation = { packagePurchased: "", subscriptionLength: 0, quantity: 0, total: 0, grandTotal: 0 }

        $scope.selectedInstitute = {
            InstitutionId: 0,
            InstitutionName: '',
            isAffiliationExists: false,
            userDefinedAffiliation: ''
        };

        $scope.getSignature = function (upgradeData) {
            
            upgradeService.getSignature(upgradeData).then(function (response) {
                if (response != null && response.data.message != undefined) {
                    $scope.message = response.data.message;
                    $scope.isError = true;
                    $scope.isSuccess = false;
                }
                else {

                    var data = response.data.signature;

                    $scope.cybersourceAPI = response.data.signature.CyberSourceTokenAPI;
                    document.payment_confirmation.action = $scope.cybersourceAPI;
                    document.autorenewal_payment_confirmation.action = $scope.cybersourceAPI;

                    var payData = {
                        access_key: data.access_key,
                        profile_id: data.profile_id,
                        transaction_uuid: data.transaction_uuid,
                        signed_field_names: data.signed_field_names,
                        unsigned_field_names: data.unsigned_field_names,
                        signed_date_time: data.signed_date_time,
                        locale: data.locale,
                        transaction_type: data.transaction_type,
                        reference_number: data.reference_number,
                        amount: data.amount,
                        currency: data.currency,
                        signature: data.signature,
                        bill_to_forename: data.bill_to_forename,
                        bill_to_surname: data.bill_to_surname,
                        bill_to_email: data.bill_to_email,
                        bill_to_address_line1: data.bill_to_address_line1,
                        bill_to_address_line2: data.bill_to_address_line2,
                        bill_to_address_city: data.bill_to_address_city,
                        bill_to_address_postal_code: data.bill_to_address_postal_code,
                        bill_to_address_state: data.bill_to_address_state,
                        bill_to_address_country: data.bill_to_address_country,
                        recurring_frequency: data.recurring_frequency,
                        recurring_amount: data.recurring_amount,
                        recurring_start_date: data.recurring_start_date,
                        override_custom_cancel_page: data.override_custom_cancel_page,
                        override_custom_receipt_page: data.override_custom_receipt_page,
                        override_backoffice_post_url: data.override_backoffice_post_url
                    }

                    $scope.GetSignature = payData;
                    if (data.eSpectraRecurringBillFlag == 1) {
                        window.setTimeout(function () {
                            $('#autorenewalsubmit').click();
                        }, 100)
                    } else {
                        window.setTimeout(function () {
                            $('#submit').click();
                        }, 100)
                    }
                    progressBarService.hideProgressBar();
                }
            });
        }

        $scope.disableSearchInstitute = function (e) {
            if ($(e.currentTarget).prop('checked')) {
                $('#affiliationName').attr('disabled', 'disabled');
            } else {
                $('#affiliationName').removeAttr('disabled');
            }
            $('#affiliationName').val('');
            $scope.searchAffiliation = "";
            $scope.selectedInstitute.InstitutionName = "";
            $scope.selectedInstitute.userDefinedAffiliation = "";
        }

        $scope.setAffiliation = function () {
            if ($scope.selectedInstitute.InstitutionName.length > 0 || $scope.selectedInstitute.userDefinedAffiliation.length > 0) {
                $scope.subscribtionData.InstitutionId = parseInt($scope.selectedInstitute.InstitutionId) > 0 ? $scope.selectedInstitute.InstitutionId : 0;
                $scope.subscribtionData.InstitutionName = $scope.selectedInstitute.InstitutionName != '' ? $scope.selectedInstitute.InstitutionName : $scope.selectedInstitute.userDefinedAffiliation;

                $('#affiliation').modal('hide');
            }
        };

        $scope.chkmonthlySubscriptions = function (event) {

            var isChecked = $(event.currentTarget)[0].checked;
            
            $scope.subscribtionData.purchaseNumber = 0;
            $scope.subscribtionData.subscriptionLength = "1";

            if (isChecked) {
                $('.annualChk').prop('checked', '')

                $scope.annualcheckMe = true;
                $scope.annualDisabled = true;
                $scope.monthlycheckMe = true;

                $('.annualChk').removeClass('ng-invalid');
                $('.annualChk').removeClass('border-all-red');

                $scope.subscribtionData.monthlySubscription = true;
                $scope.subscribtionData.annualSubscription = false;

                $scope.subscribtionData.purchaseNumber = 1;
                $scope.purchasedCostEstimation.quantity = 1
                $scope.subscribtionData.productId = $(event.currentTarget).attr('data-product');
                $scope.purchasedCostEstimation.grandTotal = $scope.monthlySubscriptions[0].eSpectraUnitPrice;

                $scope.purchasedCostEstimation.packagePurchased = "Monthly Individual";
            }
            else {
                $('.annualChk').addClass('ng-invalid');

                $scope.annualcheckMe = false;
                $scope.annualDisabled = false;
                $scope.monthlycheckMe = false;

                $scope.subscribtionData.monthlySubscription = false;
                $scope.subscribtionData.annualSubscription = false;

            }
        }
        $scope.chkannualSubscriptions = function (e) {
            var selectedCheckbox = $(e.currentTarget);
            var FieldShellelements, i, checkedCheckboxesLength, checkedCheckboxes;
            $scope.subscribtionData.productId = selectedCheckbox.attr('data-product');
            FieldShellelements = $(".annualChk");

            for (i = 0; i < FieldShellelements.length; i++) {
                $(FieldShellelements[i]).removeClass('ng-invalid');
                $(FieldShellelements[i]).removeClass('border-all-red');
            };

            checkedCheckboxesLength = $('.annualChk:checked').length;
            checkedCheckboxes = $('.annualChk:checked');

            if (selectedCheckbox[0].checked) {
                var fee = selectedCheckbox.attr('data-fee');
                $scope.purchasedCostEstimation.packagePurchased = "Annual Individual";
                $scope.purchasedCostEstimation.grandTotal = fee;
                
                $scope.subscribtionData.purchaseNumber = 1;
                $scope.purchasedCostEstimation.quantity = 1;

            } else {
                $scope.purchasedCostEstimation.packagePurchased = "";
                $scope.purchasedCostEstimation.subscriptionLength = 0;
                $scope.purchasedCostEstimation.quantity = 0;
                $scope.purchasedCostEstimation.total = 0;
                $scope.purchasedCostEstimation.grandTotal = 0;
            }

            for (i = 0; i < checkedCheckboxesLength; i++) {
                if ($(checkedCheckboxes[i]).attr('id') != selectedCheckbox.attr('id')) {
                    checkedCheckboxes[i].checked = false;
                }
            }

            if (checkedCheckboxesLength > 0) {
                $('.monthlyChk').removeClass('ng-invalid');
                $('.monthlyChk').removeClass('border-all-red');

                $('.monthlyChk').prop('checked', '')

                $scope.monthlycheckMe = true;
                $scope.monthlyDisabled = true;
                $scope.annualcheckMe = true;

                $scope.subscribtionData.monthlySubscription = false;
                $scope.subscribtionData.annualSubscription = true;

            } else {
                $('.monthlyChk').addClass('ng-invalid');
                $('.annualChk').addClass('ng-invalid');

                $scope.monthlycheckMe = false;
                $scope.monthlyDisabled = false;
                $scope.annualcheckMe = false;

                $scope.subscribtionData.monthlySubscription = false;
                $scope.subscribtionData.annualSubscription = false;
            }
        }

        $scope.chkbillingAddress = function () {

            var isChecked = $('#chkBiling')[0].checked;
            if (isChecked) {
                $scope.isBillingAddressSame = true;
                $scope.isBillingAddressSame2 = true;
                $scope.subscribtionData.billingCountry = $scope.subscribtionData.country;
                $scope.getBillingStateData($scope.subscribtionData.billingCountry);
                
                $scope.subscribtionData.billingState = $scope.subscribtionData.state;
                
                $scope.subscribtionData.billingOtherState = $scope.subscribtionData.otherState;
                

                $scope.subscribtionData.billingAddress = $scope.subscribtionData.address;
                $scope.subscribtionData.billingAddress2 = $scope.subscribtionData.address2;
                $scope.subscribtionData.billingCity = $scope.subscribtionData.city;
                $scope.subscribtionData.billingzipCode = $scope.subscribtionData.zipCode;

                $scope.selectedBillingCountryZipCodeRegEx = $scope.selectedCountryZipCodeRegEx;
                $scope.billingCountryZipCodeRequiredFlag = $scope.countryZipCodeRequiredFlag;

            }
            else {
                $scope.isBillingAddressSame = false;
                $scope.isBillingAddressSame2 = false;
            }

        }

        $scope.$watch('[subscribtionData.state, subscribtionData.otherState,subscribtionData.address,subscribtionData.address2,subscribtionData.city,subscribtionData.zipCode]', function (newValue, oldValue) {
            $scope.chkbillingAddress();
        });

        $scope.subscribtionDataModel = function () {
            $scope.subscribtionData = {

                firstName: "",
                lastName: "",
                emailId: $scope.email,
                address: "",
                address2: "",
                city: "",
                state: "",
                otherState: "",
                country: "",
                zipCode: "",
                billingAddress: "",
                billingAddress2: "",
                billingCity: "",
                billingState: "",
                billingOtherState: "",
                billingCountry: "",
                billingzipCode: "",
                autoRenewal: true,

                productId: 1,
                subscriptionLength: "1",
                purchaseNumber: 0,
                administratorPrivileges: getLocalValue('userRole') == 'IAdmin' && (getLocalValue('userRoleStatus') == 'active' || getLocalValue('userRoleStatus') == 'pending' || getLocalValue('userRoleStatus') == 'rejected') ? true : false,
                isAdmin: getLocalValue('userRole') == 'IAdmin' && (getLocalValue('userRoleStatus') == 'active' || getLocalValue('userRoleStatus') == 'pending' || getLocalValue('userRoleStatus') == 'rejected') ? true : false,
                administratorEmailId: "",
                monthlySubscription: false,
                annualSubscription: false,
                subscribtionName: "",
                fee: "",
                monthlyChk: false,
                InstitutionId: 0,
                InstitutionName: ""
            }

            $('form[name="subscribtionForm"]').trigger('reset');
            if (this.subscribtionForm) {
                this.subscribtionForm.$setPristine();
                this.subscribtionForm.$setUntouched();
            }
        }

        var hideMessage = function () {
            $scope.isError = false;
            $scope.isSuccess = false;
            $scope.message = ''
        }

        $scope.getSubscription = function (isValid) {
            var selectedState;

            if ($scope.billingstates.length > 0) {
                selectedState = $scope.subscribtionData.billingState;
            }
            
            if ($scope.states.length > 0) {
                if ($scope.subscribtionData.state == "") {
                    $scope.subscribtionData.state.$dirty = false;
                }
            }
            else if ($scope.subscribtionData.billingAddress == "") {
                $scope.subscribtionData.billingAddress.$dirty = false;
            }
            else if ($scope.subscribtionData.billingCity == "") {
                $scope.subscribtionData.billingCity.$dirty = false;
            }
            else if (selectedState == "") {
                $scope.subscribtionData.billingState.$dirty = false;
                $scope.subscribtionData.billingOtherState.$dirty = false;
            }
            else if ($scope.billingCountryZipCodeRequiredFlag === '1') {
                if ($scope.subscribtionData.billingzipCode == "") {
                    $scope.subscribtionData.billingzipCode.$dirty = false;
                }
            }


            if (isValid) {
                progressBarService.showProgressBar();

                var upgradeData = {
                    eSpectraLicenceKeyStatus: 'Assigned',
                    eSpectraSubAssignedPersonEmail: $scope.subscribtionData.emailId,
                    eSpectraOrderStartDate: new Date(),
                    eSpectraInstitutionId: $scope.subscribtionData.InstitutionId,
                    eSpectraInstitutionName: $scope.subscribtionData.InstitutionName == "" ? $scope.institutionName : $scope.subscribtionData.InstitutionName,
                    eSpectraFirstName: $scope.firstName,
                    eSpectraLastName: $scope.lastName,
                    eSpectraOrderQty: $scope.subscribtionData.purchaseNumber,
                    eSpectraOrderIsMonthly: $scope.subscribtionData.monthlySubscription ? 1 : 0,
                    eSpectraOrderTS: new Date(),
                    eSpectraProductID: $scope.subscribtionData.productId,
                    eSpectraCCBillFirstName: $scope.subscribtionData.firstName,
                    eSpectraCCBillLastName: $scope.subscribtionData.lastName,
                    eSubscriptionLength: $scope.subscribtionData.subscriptionLength,
                    eSpectraOrderTotalCost: $scope.purchasedCostEstimation.grandTotal,
                    eSpectraCCBillStreetAddrs1: $scope.subscribtionData.billingAddress,
                    eSpectraCCBillStreetAddrs2: $scope.subscribtionData.billingAddress2,
                    eSpectraCCBillCity: $scope.subscribtionData.billingCity,
                    eSpectraCCBillZipPostalCode: $scope.subscribtionData.billingzipCode,
                    eSpectraCCBillStateCode: selectedState,
                    eSpectraCCBillCountryID: $scope.subscribtionData.billingCountry,
                    eSpectraRecurringBillFlag: $scope.subscribtionData.autoRenewal ? 1 : 0
                }
                $scope.getSignature(upgradeData);
            }

        }

        $scope.validateSubscriptionDetails = function () {
            var returnVal = true;
            if (angular.element("#firstName").val() != '') {
                $("#firstName").removeClass("border-red");
                $("#firstName").siblings("label").find("span").fadeOut();
            }
            else {
                //$("#firstName").addClass("border-red");
                if (returnVal) {
                    $("#firstName").focus();
                }
                $("#firstName").siblings("label").find("span").fadeIn();
                returnVal = false;
            }
            if (angular.element("#lastName").val() != '') {
                $("#lastName").removeClass("border-red");
                $("#lastName").siblings("label").find("span").fadeOut();
            }
            else {
                //$("#lastName").addClass("border-red");
                if (returnVal) {
                    $("#lastName").focus();
                }
                $("#lastName").siblings("label").find("span").fadeIn();
                returnVal = false;
            }
            if (angular.element("#address").val() != '') {
                $("#address").removeClass("border-red");
                $("#address").siblings("label").find("span").fadeOut();
            }
            else {
                //$("#lastName").addClass("border-red");
                if (returnVal) {
                    $("#address").focus();
                }
                $("#address").siblings("label").find("span").fadeIn();
                returnVal = false;
            }
            if (angular.element("#city").val() != '') {
                $("#city").removeClass("border-red");
                $("#city").siblings("label").find("span").fadeOut();
            }
            else {
                //$("#lastName").addClass("border-red");
                if (returnVal) {
                    $("#city").focus();
                }
                $("#city").siblings("label").find("span").fadeIn();
                returnVal = false;
            }
            if (angular.element("#state").val() != '') {
                $("#state").removeClass("border-red");
                $("#state").siblings("label").find("span").fadeOut();
            }
            else {
                //$("#lastName").addClass("border-red");
                if (returnVal) {
                    $("#state").focus();
                }
                $("#state").siblings("label").find("span").fadeIn();
                returnVal = false;
            }
            if (angular.element("#zipCode").val() != '') {
                $("#zipCode").removeClass("border-red");
                $("#zipCode").siblings("label").find("span").fadeOut();
            }
            else {
                //$("#lastName").addClass("border-red");
                if (returnVal) {
                    $("#zipCode").focus();
                }
                $("#zipCode").siblings("label").find("span").fadeIn();
                returnVal = false;
            }
            if (angular.element("#emailId").val() != '') {
                var email = angular.element("#emailId").val();
                var regExp = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,3}|[0-9]{1,3})(\]?)$/;

                var isValid = regExp.test(email);
                if (isValid) {
                    $scope.registrationData.emailId = $("#inputEmailId").val();
                    $("#emailId").removeClass("border-red");
                    $("#emailId").siblings("label").find("span").fadeOut();
                }
                else {
                    //$("#inputEmailId").addClass("border-red");
                    if (returnVal) {
                        $("#emailId").focus();
                    }
                    $("#emailId").siblings("label").find("span").fadeIn();
                    returnVal = false;
                }
            }
            else {
                //$("#inputEmailId").addClass("border-red");
                if (returnVal) {
                    $("#emailId").focus();
                }
                $("#emailId").siblings("label").find("span").fadeIn();
                returnVal = false;
            }

            if (angular.element("#billingAddress").val() != '') {
                $("#billingAddress").removeClass("border-red");
                $("#billingAddress").siblings("label").find("span").fadeOut();
            }
            else {
                //$("#lastName").addClass("border-red");
                if (returnVal) {
                    $("#billingAddress").focus();
                }
                $("#billingAddress").siblings("label").find("span").fadeIn();
                returnVal = false;
            }

            if (angular.element("#billingCity").val() != '') {
                $("#billingCity").removeClass("border-red");
                $("#billingCity").siblings("label").find("span").fadeOut();
            }
            else {
                //$("#lastName").addClass("border-red");
                if (returnVal) {
                    $("#billingCity").focus();
                }
                $("#billingCity").siblings("label").find("span").fadeIn();
                returnVal = false;
            }
            
            if (angular.element("#billingzipCode").val() != '') {
                $("#billingzipCode").removeClass("border-red");
                $("#billingzipCode").siblings("label").find("span").fadeOut();
            }
            else {
                //$("#lastName").addClass("border-red");
                if (returnVal) {
                    $("#billingzipCode").focus();
                }
                $("#billingzipCode").siblings("label").find("span").fadeIn();
                returnVal = false;
            }

            if (!returnVal) {
                this.subscribtionForm.$dirty = true;
                this.subscribtionForm.firstName.$dirty = true;
                this.subscribtionForm.lastName.$dirty = true;
                this.subscribtionForm.address.$dirty = true;
                this.subscribtionForm.city.$dirty = true;
                this.subscribtionForm.state.$dirty = true;
                this.subscribtionForm.country.$dirty = true;
                this.subscribtionForm.zipCode.$dirty = true;
                this.subscribtionForm.emailId.$dirty = true;
                this.subscribtionForm.month.$dirty = true;
                this.subscribtionForm.date.$dirty = true;
                this.subscribtionForm.year.$dirty = true;

                this.subscribtionForm.billingAddress.$dirty = true;
                this.subscribtionForm.billingCity.$dirty = true;
                this.subscribtionForm.billingState.$dirty = true;
                this.subscribtionForm.billingCountry.$dirty = true;
                this.subscribtionForm.billingzipCode.$dirty = true;
            }

            return returnVal;
        }

        $scope.getProducts = function () {
            progressBarService.showProgressBar();
            upgradeService.getSubscriptionProducts().then(function (response) {

                if (response != null && response.data.message != undefined) {
                    $scope.message = response.data.message;
                    $scope.isError = true;
                    $scope.isSuccess = false;
                }
                else {

                    $scope.monthlySubscriptions = response.data.monthlySusription;
                    $scope.annualSubscriptions = response.data.yearlySuscription;
                    $scope.email = response.data.loggedInEmailId;
                    $scope.subscribtionData.emailId = $scope.email;

                    loginService.setUserDetail($scope.email).then(function (response) {
                        if (response != null && response.data.message == undefined) {
                            var userData = response.data;

                            $scope.subscribtionData.state = userData.eSpectraStateCode;
                            $scope.subscribtionData.otherState = userData.eSpectraStateCode;

                            $scope.subscribtionData.firstName = userData.eSpectraFirstName;
                            $scope.subscribtionData.lastName = userData.eSpectraLastName;
                            $scope.subscribtionData.emailId = userData.eSpectraEmail;
                            $scope.subscribtionData.address = userData.eSpectraStreetAddrs1;
                            $scope.subscribtionData.address2 = userData.eSpectraStreetAddrs2;
                            $scope.subscribtionData.city = userData.eSpectraCity;
                            $scope.subscribtionData.country = userData.countryIso2,
                            $scope.subscribtionData.zipCode = userData.eSpectraZipPostalCode;

                            if (userData.eSpectraRecurringBillFlag == "1") {
                                $location.path('/profile');
                            }

                            $scope.getcountryData();
                        }

                        progressBarService.hideProgressBar();
                    });
                }
            });
        }

        $scope.getProducts();

        $scope.subscribtionDataModel();

        var serviceBase = $rootScope.buildConfig.aippsssApiBaseUrl;

        // Instantiate the Bloodhound suggestion engine
        var institutions = new Bloodhound({
            datumTokenizer: Bloodhound.tokenizers.obj.whitespace('value'),
            queryTokenizer: Bloodhound.tokenizers.whitespace,
            remote: {
                url: serviceBase + 'api/Account/institutions?query=%QUERY',
                prepare: function (query, settings) {
                    settings.beforeSend = (function () {
                        $('.autopopulate-spinner').show();
                        $scope.$apply();
                    })();
                    return $.extend(settings, {
                        url: settings.url.replace('%QUERY', encodeURIComponent(query)),
                        error: function (jqxhr, textStatus, errorThrown) {

                            $('.autopopulate-spinner').hide();
                        },
                        success: function (data, textStatus, jqxhr) {
                        }
                    });
                },
                clearRemoteCache: function clearRemoteCache() {
                    this.transport && Transport.resetCache();
                },
                filter: function (institutions) {
                    $('.autopopulate-spinner').hide();
                    return $.map(institutions, function (institution) {
                        return {
                            value: institution.institutionName,
                            institutionCity: institution.institutionCity,
                            institutionState: institution.institutionState,
                            institutionMstrID: institution.institutionMstrID,
                            institutionCountryCode: institution.institutionCountryCode
                        };
                    });
                }
            }
        });

        // Initialize the Bloodhound suggestion engine
        institutions.initialize();

        // Instantiate the Typeahead UI

        $("#affiliationName").typeahead({
            hint: false,
            highlight: true,
            minLength: 3
        },
        {
            displayKey: 'value',
            minLength: 3,
            limit: 10,
            dupChecker: true,
            source: institutions.ttAdapter(),
            templates: {
                suggestion: function (data) {
                    return "<div>" + data.value + ", " + data.institutionCity + ", " + data.institutionState + ", " + data.institutionCountryCode + " </div>";
                },
                empty: [
                        '<div style="background-color: #eeeeee;padding: 2px 5px;color: #000;">',
                            '<div style="display:inline-block">No Items Found</div>',
                        '</div>'
                ].join('\n')
            }
        }).bind('typeahead:selected', function (obj, datum, name) {

            $scope.selectedInstitute.InstitutionId = datum.institutionMstrID
            $scope.selectedInstitute.InstitutionName = datum.value;

            $scope.$apply();
            return false;
        });

        //to test zip code valid or not at the time of page load
        $scope.$on('$viewContentLoaded', function () {
            $timeout(function () {
                $scope.selectedCountryZipCodeRegEx = $('option:selected', $('#country')).attr('validateRegex');
                $scope.countryZipCodeRequiredFlag = $('option:selected', $('#country')).attr('countryZipCodeRequiredFlag') === "true" ? true : false;
                if ($scope.subscribtionData.zipCode != '') {
                    var emailregx = new RegExp($scope.selectedCountryZipCodeRegEx);
                    if (!emailregx.test($scope.subscribtionData.zipCode)) {
                        $scope.subscribtionForm.zipCode.$dirty = true;
                        $scope.subscribtionForm.zipCode.$invalid = true;
                    }
                }
            }, 2000);
        });

        $scope.getstateData = function (code) {
            $scope.selectedCountryZipCodeRegEx = $('option:selected', $('#country')).attr('validateRegex');
            $scope.countryZipCodeRequiredFlag = $('option:selected', $('#country')).attr('countryZipCodeRequiredFlag') === "true" ? true : false;
            upgradeService.getstateData(code).then(function (response) {
                if (response != null && response.data.message != undefined) {

                    $scope.message = response.data.message;
                    $scope.isError = true;
                    $scope.isSuccess = false;
                }
                else {
                    $scope.states = response.data;
                    $scope.chkbillingAddress();
                    if ($scope.states.length > 0) {
                        $scope.subscribtionData.otherState = "";
                    } else {
                        $scope.subscribtionData.state = "";
                    }

                }
            });
            if ($scope.subscribtionData.zipCode != '') {
                this.subscribtionForm.$dirty = true;
                this.subscribtionForm.zipCode.$dirty = true;
            }
        }

        $scope.getBillingStateData = function (code) {

            upgradeService.getstateData(code).then(function (response) {
                if (response != null && response.data.message != undefined) {

                    $scope.message = response.data.message;
                    $scope.isError = true;
                    $scope.isSuccess = false;
                }
                else {
                    $scope.billingstates = response.data;
                }
                progressBarService.hideProgressBar();
            });

            $scope.selectedBillingCountryZipCodeRegEx = $('option:selected', $('#billingCountry')).attr('validateRegex');
            $scope.billingCountryZipCodeRequiredFlag = $('option:selected', $('#billingCountry')).attr('countryZipCodeRequiredFlag') === "true" ? true : false;
            if ($scope.billingstates.length > 0) {
                $scope.subscribtionData.billingState = "";
                $scope.subscribtionData.billingOtherState = "";
            }

            if ($scope.subscribtionData.billingzipCode != '') {
                this.subscribtionForm.$dirty = true;
                this.subscribtionForm.billingzipCode.$dirty = true;
            }
        }

        $scope.getcountryData = function () {
            progressBarService.showProgressBar();
            upgradeService.getcountryData().then(function (response) {
                if (response != null && response.data.message != undefined) {
                    $scope.message = response.data.message;
                    $scope.isError = true;
                    $scope.isSuccess = false;
                }
                else {
                    $scope.countries = response.data;
                    $scope.getstateData($scope.subscribtionData.country)
                }
                progressBarService.hideProgressBar();
            });
        }



    }]);
})();